/*** Update price on Product Page when quantity is changed ***/

window.addEventListener("variant:changed", function(evt) {
  window.variant_base_price = evt.detail.price;
  $('#quantity').val(1).change();
}, false);

document.addEventListener("DOMContentLoaded", function() {
  $('#quantity').change(function() {
    var prc = parseInt(window.variant_base_price) * parseInt($(this).val());
    $('.js-product-section .price-ui .price .money').text(window.Shopify.formatMoney(prc, $('body').data('money-format')));
    if (typeof updateShipping !== 'undefined') {
      updateShipping();
    }
  });
});

/*** End Update price on Product Page when quantity is changed ***/

/*** Add priority order processing to Cart ***/
document.addEventListener("DOMContentLoaded", () => {

  let priorityShippingVariantID;

  if (window.location.href.includes("organics-best-test-store")) { 
    priorityShippingVariantID = 42186647240948;
  } else {
    priorityShippingVariantID = 38054108266682;
  }


  // getCart object - function
  async function getCart() {
    const result = await fetch("/cart.json");

    if (result.status === 200) {
        return result.json();
    }
    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
  }

   // addItem to cart - function
   async function addItem(variantId, quantity) {
       const result = await fetch("/cart/add.json", {
           method: "POST",
           headers: {
               "Content-Type": "application/json",
               "Accept": "application/json"
           },
           body: JSON.stringify({
               id: variantId,
               quantity: quantity
           })
       })
   }

    // check if priorityShippingInCart
    (async() => {
      const cart = await getCart();
        console.log(cart);
            var priorityShippingInCart = false;
            for (const cartItem of cart.items) {
                if (cartItem.id == priorityShippingVariantID) {
                  console.log("priority shipping in cart");
                  priorityShippingInCart = true;
                  const priorityOrderWrapper = document.querySelector('.custom-priority-order__wrapper');
                  priorityOrderWrapper.style.display = 'none';
                }
            }
    })()   

  // add priorityShipping to cart if checkbox is checked
 const checkbox = document.getElementById('checkbox-priority-order');
  const button = document.querySelector('.add_to_cart.global-button.global-button--primary[name="add"]');
     button.addEventListener('click', async function(event) {
        if (checkbox.checked) {
           event.preventDefault();
            const formElement = button.closest('form');
            console.log(formElement);
            try {
              console.log("start");
              await addItem(priorityShippingVariantID, 1);
              console.log("end");
              
              // Submit the form after the asynchronous operation is complete
              formElement.submit();
            } catch (error) {
              // Handle any errors that might occur during the asynchronous operation
              console.error("An error occurred:", error);
            }
      }
  });
});
/*** End Add priority order processing to Cart ***/